import React, { useEffect, useState } from "react";
import "./Settlements.css";
import { getSettlementAmount } from "../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DateFilter from "../../components/common/DateFilter";

const GetSettlements = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchSettlementData = async (start, end) => {
    setIsLoading(true);
    try {
      const response = await getSettlementAmount(start, end);
      setTableData(response || []);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSettlementData(startDate, endDate);
    }
  }, [token, startDate, endDate]);

  // ✅ SINGLE SOURCE OF TRUTH
  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    fetchSettlementData(start, end);
  };

  return (
    <div className="settlement-table-container">
      <div className="analytics-header">
        <h2 className="settlement-table-title">Provider Settlement</h2>
      </div>

      {/* ✅ COMMON DATE FILTER */}
      <DateFilter onDateChange={handleDateChange} />

      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <table className="settlement-table">
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Organization Name</th>
              <th>Total Settlement Amount</th>
              <th>12AM - 5AM (INR)</th>
              <th>5AM - 7AM (INR)</th>
              <th>7AM - 1PM (INR)</th>
              <th>1PM - 7PM (INR)</th>
              <th>7PM - 12AM (INR)</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((provider) => (
              <tr key={provider.providerId}>
                <td>{provider.providerName}</td>
                <td>{provider.orgName}</td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0].total_transactions
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0]["12am - 5am"]
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0]["5am - 7am"]
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0]["7am - 1pm"]
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0]["1pm - 7pm"]
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>

                <td>
                  {provider.transactions?.length
                    ? `₹ ${parseFloat(
                        provider.transactions[0]["7pm - 12am"]
                      ).toFixed(2)}`
                    : "₹ 0.00"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default GetSettlements;